var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 151,
    viewBox: "0 0 452 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.956143 123V122.233L3.83683 119.08C4.17489 118.71 4.4533 118.389 4.67205 118.116C4.8908 117.841 5.05273 117.582 5.15785 117.341C5.2658 117.097 5.31978 116.841 5.31978 116.574C5.31978 116.267 5.24592 116.001 5.09819 115.777C4.9533 115.553 4.75444 115.379 4.5016 115.257C4.24876 115.135 3.96467 115.074 3.64933 115.074C3.3141 115.074 3.02148 115.143 2.77148 115.283C2.52433 115.419 2.33256 115.611 2.1962 115.858C2.06268 116.105 1.99592 116.395 1.99592 116.727H0.990234C0.990234 116.216 1.10813 115.767 1.34393 115.381C1.57972 114.994 1.90075 114.693 2.307 114.477C2.71609 114.261 3.17489 114.153 3.68342 114.153C4.19478 114.153 4.6479 114.261 5.04279 114.477C5.43768 114.693 5.74734 114.984 5.97177 115.351C6.1962 115.717 6.30842 116.125 6.30842 116.574C6.30842 116.895 6.25018 117.209 6.1337 117.516C6.02006 117.82 5.8212 118.159 5.53711 118.534C5.25586 118.906 4.86523 119.361 4.36523 119.898L2.40501 121.994V122.062H6.46183V123H0.956143ZM10.949 123.119C10.449 123.119 9.99876 123.02 9.59819 122.821C9.19762 122.622 8.8766 122.349 8.63512 122.003C8.39364 121.656 8.26154 121.261 8.23881 120.818H9.26154C9.30131 121.213 9.48029 121.54 9.79847 121.798C10.1195 122.054 10.503 122.182 10.949 122.182C11.307 122.182 11.6252 122.098 11.9036 121.93C12.1848 121.763 12.405 121.533 12.5641 121.24C12.726 120.945 12.807 120.611 12.807 120.239C12.807 119.858 12.7232 119.518 12.5556 119.22C12.3908 118.919 12.1635 118.682 11.8738 118.509C11.584 118.335 11.253 118.247 10.8809 118.244C10.6138 118.241 10.3397 118.283 10.0584 118.368C9.77717 118.45 9.54563 118.557 9.36381 118.688L8.37518 118.568L8.90359 114.273H13.4377V115.21H9.78995L9.48313 117.784H9.53427C9.71325 117.642 9.93768 117.524 10.2076 117.43C10.4775 117.337 10.7587 117.29 11.0513 117.29C11.5854 117.29 12.0613 117.418 12.4789 117.673C12.8993 117.926 13.2289 118.273 13.4675 118.713C13.709 119.153 13.8297 119.656 13.8297 120.222C13.8297 120.778 13.7047 121.276 13.4547 121.713C13.2076 122.148 12.8667 122.491 12.432 122.744C11.9973 122.994 11.503 123.119 10.949 123.119ZM18.3691 123.119C17.7271 123.119 17.1802 122.945 16.7285 122.595C16.2768 122.243 15.9316 121.733 15.693 121.065C15.4544 120.395 15.335 119.585 15.335 118.636C15.335 117.693 15.4544 116.888 15.693 116.22C15.9345 115.55 16.2811 115.038 16.7328 114.686C17.1873 114.331 17.7328 114.153 18.3691 114.153C19.0055 114.153 19.5495 114.331 20.0012 114.686C20.4558 115.038 20.8024 115.55 21.041 116.22C21.2825 116.888 21.4032 117.693 21.4032 118.636C21.4032 119.585 21.2839 120.395 21.0453 121.065C20.8066 121.733 20.4615 122.243 20.0098 122.595C19.5581 122.945 19.0112 123.119 18.3691 123.119ZM18.3691 122.182C19.0055 122.182 19.4998 121.875 19.8521 121.261C20.2044 120.648 20.3805 119.773 20.3805 118.636C20.3805 117.881 20.2995 117.237 20.1376 116.706C19.9785 116.175 19.7484 115.77 19.4473 115.491C19.149 115.213 18.7896 115.074 18.3691 115.074C17.7385 115.074 17.2456 115.385 16.8904 116.007C16.5353 116.626 16.3578 117.503 16.3578 118.636C16.3578 119.392 16.4373 120.034 16.5964 120.562C16.7555 121.091 16.9842 121.493 17.2825 121.768C17.5836 122.044 17.9458 122.182 18.3691 122.182ZM23.176 123V114.273H24.2328V118.602H24.335L28.2555 114.273H29.6362L25.9714 118.21L29.6362 123H28.3578L25.3237 118.943L24.2328 120.17V123H23.176Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06623 86.1193C3.56623 86.1193 3.11594 86.0199 2.71538 85.821C2.31481 85.6222 1.99379 85.3494 1.75231 85.0028C1.51083 84.6562 1.37873 84.2614 1.356 83.8182H2.37873C2.4185 84.2131 2.59748 84.5398 2.91566 84.7983C3.23668 85.054 3.62021 85.1818 4.06623 85.1818C4.42418 85.1818 4.74237 85.098 5.02077 84.9304C5.30202 84.7628 5.52219 84.5327 5.68129 84.2401C5.84322 83.9446 5.92418 83.6108 5.92418 83.2386C5.92418 82.858 5.84038 82.5185 5.67276 82.2202C5.50799 81.919 5.28072 81.6818 4.99094 81.5085C4.70117 81.3352 4.37021 81.2472 3.99805 81.2443C3.731 81.2415 3.45685 81.2827 3.1756 81.3679C2.89435 81.4503 2.66282 81.5568 2.481 81.6875L1.49237 81.5682L2.02077 77.2727H6.55487V78.2102H2.90714L2.60032 80.7841H2.65146C2.83043 80.642 3.05487 80.5241 3.32475 80.4304C3.59464 80.3366 3.87589 80.2898 4.1685 80.2898C4.70259 80.2898 5.17844 80.4176 5.59606 80.6733C6.01651 80.9261 6.34606 81.2727 6.58469 81.7131C6.82617 82.1534 6.94691 82.6562 6.94691 83.2216C6.94691 83.7784 6.82191 84.2756 6.57191 84.7131C6.32475 85.1477 5.98384 85.4915 5.54918 85.7443C5.11452 85.9943 4.62021 86.1193 4.06623 86.1193ZM11.4863 86.1193C10.8443 86.1193 10.2974 85.9446 9.8457 85.5952C9.394 85.2429 9.04883 84.733 8.81019 84.0653C8.57156 83.3949 8.45224 82.5852 8.45224 81.6364C8.45224 80.6932 8.57156 79.8878 8.81019 79.2202C9.05167 78.5497 9.39826 78.0384 9.84996 77.6861C10.3045 77.331 10.85 77.1534 11.4863 77.1534C12.1227 77.1534 12.6667 77.331 13.1184 77.6861C13.573 78.0384 13.9196 78.5497 14.1582 79.2202C14.3997 79.8878 14.5204 80.6932 14.5204 81.6364C14.5204 82.5852 14.4011 83.3949 14.1625 84.0653C13.9238 84.733 13.5787 85.2429 13.127 85.5952C12.6752 85.9446 12.1284 86.1193 11.4863 86.1193ZM11.4863 85.1818C12.1227 85.1818 12.617 84.875 12.9693 84.2614C13.3216 83.6477 13.4977 82.7727 13.4977 81.6364C13.4977 80.8807 13.4167 80.2372 13.2548 79.706C13.0957 79.1747 12.8656 78.7699 12.5645 78.4915C12.2662 78.2131 11.9068 78.0739 11.4863 78.0739C10.8556 78.0739 10.3627 78.3849 10.0076 79.0071C9.65252 79.6264 9.47496 80.5028 9.47496 81.6364C9.47496 82.392 9.55451 83.0341 9.7136 83.5625C9.87269 84.0909 10.1014 84.4929 10.3997 84.7685C10.7008 85.044 11.063 85.1818 11.4863 85.1818ZM18.9863 86.1193C18.3443 86.1193 17.7974 85.9446 17.3457 85.5952C16.894 85.2429 16.5488 84.733 16.3102 84.0653C16.0716 83.3949 15.9522 82.5852 15.9522 81.6364C15.9522 80.6932 16.0716 79.8878 16.3102 79.2202C16.5517 78.5497 16.8983 78.0384 17.35 77.6861C17.8045 77.331 18.35 77.1534 18.9863 77.1534C19.6227 77.1534 20.1667 77.331 20.6184 77.6861C21.073 78.0384 21.4196 78.5497 21.6582 79.2202C21.8997 79.8878 22.0204 80.6932 22.0204 81.6364C22.0204 82.5852 21.9011 83.3949 21.6625 84.0653C21.4238 84.733 21.0787 85.2429 20.627 85.5952C20.1752 85.9446 19.6284 86.1193 18.9863 86.1193ZM18.9863 85.1818C19.6227 85.1818 20.117 84.875 20.4693 84.2614C20.8216 83.6477 20.9977 82.7727 20.9977 81.6364C20.9977 80.8807 20.9167 80.2372 20.7548 79.706C20.5957 79.1747 20.3656 78.7699 20.0645 78.4915C19.7662 78.2131 19.4068 78.0739 18.9863 78.0739C18.3556 78.0739 17.8627 78.3849 17.5076 79.0071C17.1525 79.6264 16.975 80.5028 16.975 81.6364C16.975 82.392 17.0545 83.0341 17.2136 83.5625C17.3727 84.0909 17.6014 84.4929 17.8997 84.7685C18.2008 85.044 18.563 85.1818 18.9863 85.1818ZM23.7931 86V77.2727H24.85V81.6023H24.9522L28.8727 77.2727H30.2534L26.5886 81.2102L30.2534 86H28.975L25.9409 81.9432L24.85 83.1705V86H23.7931Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49254 49L5.39595 41.2784V41.2102H0.895952V40.2727H6.48686V41.2614L2.6005 49H1.49254ZM10.6854 49.1193C10.1854 49.1193 9.73509 49.0199 9.33452 48.821C8.93395 48.6222 8.61293 48.3494 8.37145 48.0028C8.12997 47.6562 7.99787 47.2614 7.97514 46.8182H8.99787C9.03764 47.2131 9.21662 47.5398 9.5348 47.7983C9.85582 48.054 10.2393 48.1818 10.6854 48.1818C11.0433 48.1818 11.3615 48.098 11.6399 47.9304C11.9212 47.7628 12.1413 47.5327 12.3004 47.2401C12.4624 46.9446 12.5433 46.6108 12.5433 46.2386C12.5433 45.858 12.4595 45.5185 12.2919 45.2202C12.1271 44.919 11.8999 44.6818 11.6101 44.5085C11.3203 44.3352 10.9893 44.2472 10.6172 44.2443C10.3501 44.2415 10.076 44.2827 9.79474 44.3679C9.51349 44.4503 9.28196 44.5568 9.10014 44.6875L8.11151 44.5682L8.63991 40.2727H13.174V41.2102H9.52628L9.21946 43.7841H9.2706C9.44957 43.642 9.67401 43.5241 9.94389 43.4304C10.2138 43.3366 10.495 43.2898 10.7876 43.2898C11.3217 43.2898 11.7976 43.4176 12.2152 43.6733C12.6357 43.9261 12.9652 44.2727 13.2038 44.7131C13.4453 45.1534 13.5661 45.6562 13.5661 46.2216C13.5661 46.7784 13.4411 47.2756 13.1911 47.7131C12.9439 48.1477 12.603 48.4915 12.1683 48.7443C11.7337 48.9943 11.2393 49.1193 10.6854 49.1193ZM18.1055 49.1193C17.4634 49.1193 16.9165 48.9446 16.4648 48.5952C16.0131 48.2429 15.668 47.733 15.4293 47.0653C15.1907 46.3949 15.0714 45.5852 15.0714 44.6364C15.0714 43.6932 15.1907 42.8878 15.4293 42.2202C15.6708 41.5497 16.0174 41.0384 16.4691 40.6861C16.9237 40.331 17.4691 40.1534 18.1055 40.1534C18.7418 40.1534 19.2859 40.331 19.7376 40.6861C20.1921 41.0384 20.5387 41.5497 20.7773 42.2202C21.0188 42.8878 21.1396 43.6932 21.1396 44.6364C21.1396 45.5852 21.0202 46.3949 20.7816 47.0653C20.543 47.733 20.1978 48.2429 19.7461 48.5952C19.2944 48.9446 18.7475 49.1193 18.1055 49.1193ZM18.1055 48.1818C18.7418 48.1818 19.2362 47.875 19.5884 47.2614C19.9407 46.6477 20.1168 45.7727 20.1168 44.6364C20.1168 43.8807 20.0359 43.2372 19.8739 42.706C19.7148 42.1747 19.4847 41.7699 19.1836 41.4915C18.8853 41.2131 18.5259 41.0739 18.1055 41.0739C17.4748 41.0739 16.9819 41.3849 16.6268 42.0071C16.2717 42.6264 16.0941 43.5028 16.0941 44.6364C16.0941 45.392 16.1737 46.0341 16.3327 46.5625C16.4918 47.0909 16.7205 47.4929 17.0188 47.7685C17.32 48.044 17.6822 48.1818 18.1055 48.1818ZM22.9123 49V40.2727H23.9691V44.6023H24.0714L27.9918 40.2727H29.3725L25.7077 44.2102L29.3725 49H28.0941L25.06 44.9432L23.9691 46.1705V49H22.9123Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3446 3.27273V12H10.2878V4.38068H10.2367L8.106 5.79545V4.72159L10.2878 3.27273H11.3446ZM14.008 3.27273H15.2694L18.2353 10.517H18.3375L21.3034 3.27273H22.5648V12H21.5762V5.36932H21.4909L18.7637 12H17.8091L15.0819 5.36932H14.9966V12H14.008V3.27273Z",
    fill: "white",
    fillOpacity: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 7.5,
    x2: 452,
    y2: 7.49996,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeDasharray: "2 2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 44.5,
    x2: 452,
    y2: 44.5,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeDasharray: "2 2"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 81.5,
    x2: 452,
    y2: 81.5,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeDasharray: "2 2"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 118.5,
    x2: 452,
    y2: 118.5,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeDasharray: "2 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_380_34344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78 52C78 47.5817 81.5817 44 86 44H106C110.418 44 114 47.5817 114 52V151H78V52Z",
    fill: "white",
    fillOpacity: 0.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_380_34344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146 89C146 84.5817 149.582 81 154 81H174C178.418 81 182 84.5817 182 89V151H146V89Z",
    fill: "white",
    fillOpacity: 0.05
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_380_34344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350 15C350 10.5817 353.582 7 358 7H378C382.418 7 386 10.5817 386 15V151H350V15Z",
    fill: "white",
    fillOpacity: 0.05
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_380_34344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418 52C418 47.5817 421.582 44 426 44H452V131C452 142.046 443.046 151 432 151H418V52Z",
    fill: "white",
    fillOpacity: 0.05
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_380_34344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211 52C211 47.5817 214.582 44 219 44H239C243.418 44 247 47.5817 247 52V151H211V52Z",
    fill: "white",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_380_34344",
    x: 59.4,
    y: 25.4,
    width: 73.2,
    height: 144.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_380_34344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_380_34344",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_380_34344",
    x: 127.4,
    y: 62.4,
    width: 73.2,
    height: 107.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_380_34344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_380_34344",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_380_34344",
    x: 331.4,
    y: -11.6,
    width: 73.2,
    height: 181.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_380_34344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_380_34344",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_380_34344",
    x: 399.4,
    y: 25.4,
    width: 71.2,
    height: 144.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_380_34344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_380_34344",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_380_34344",
    x: 192.4,
    y: 25.4,
    width: 73.2,
    height: 144.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_380_34344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_380_34344",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.379ac132ae6623604977552f6b438b46.svg";
export { ForwardRef as ReactComponent };